import ajax from '../ajax';
import api from '../api';

function newClinic() {
    return {
        id: 0,
        name: '',
        address: '',
        schedule: Array(7).fill([]),
        specialties: [],
    };
}

async function fetchClinics() {
    const response = await ajax.get('admin/clinics');
    return response.data;
}

async function fetchClinic(id) {
    const response = await api.get(`clinic/${id}`);
    return response.data;
}

async function searchClinics(params) {
    const response = await api.get('search-clinics', { params });
    return response.data;
}

async function hasCoupon(clinic_id) {
    const response = await ajax.get(`coupon/${clinic_id}`);
    return response.data;
}

export { newClinic, fetchClinics, fetchClinic, searchClinics, hasCoupon };
